import {Message} from 'element-ui';

export async function doFetch(url, method = 'POST', body = null, headers = {}) {
    //method to upper case
    method = method.toUpperCase();
    headers['Content-Type'] = 'application/json';
    headers['Authorization'] = 'Bearer ' + localStorage.getItem('token') || '';
    const options = {
        method: method,
        headers: headers,
        body: JSON.stringify(body)
    };
    if (method === 'GET' || method === 'HEAD') {
        delete options.body; // GET and HEAD requests should not have a body
    }
    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            return {code:response.status, msg: `HTTP网络错误${response.statusCode} ${response.statusText}`};
        }
        const res = await response.json();
        if (res.code !== 200) {
            Message.error(res.msg || '请求失败');
            console.error(`Request failed: ${res.msg}`);
        }
        return res;
    } catch (error) {
        Message.error(`Request failed: ${error.message}`);
        console.error(`Request failed: ${error.message}`);
    }
}